/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visit_Ssc_MarketplaceInputs */

const en_visit_ssc_marketplace = /** @type {(inputs: Visit_Ssc_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visit SSC Marketplace`)
};

const es_visit_ssc_marketplace = /** @type {(inputs: Visit_Ssc_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visitar mercado SSC`)
};

const fr_visit_ssc_marketplace = /** @type {(inputs: Visit_Ssc_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visiter la marketplace SSC`)
};

const de_visit_ssc_marketplace = /** @type {(inputs: Visit_Ssc_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besuche den SSC-Marktplatz`)
};

const ja_visit_ssc_marketplace = /** @type {(inputs: Visit_Ssc_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSCマーケットプレイスを見る`)
};

const zh_visit_ssc_marketplace = /** @type {(inputs: Visit_Ssc_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`访问 SSC 市场`)
};

const ar_visit_ssc_marketplace = /** @type {(inputs: Visit_Ssc_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زيارة سوق SSC`)
};

const id_visit_ssc_marketplace = /** @type {(inputs: Visit_Ssc_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunjungi Marketplace SSC`)
};

const it_visit_ssc_marketplace = /** @type {(inputs: Visit_Ssc_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visita il Marketplace SSC`)
};

const ru_visit_ssc_marketplace = /** @type {(inputs: Visit_Ssc_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посетить маркетплейс SSC`)
};

const pt_visit_ssc_marketplace = /** @type {(inputs: Visit_Ssc_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visitar o Marketplace da SSC`)
};

const ko_visit_ssc_marketplace = /** @type {(inputs: Visit_Ssc_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC 마켓플레이스 방문`)
};

/**
* | output |
* | --- |
* | "Visit SSC Marketplace" |
*
* @param {Visit_Ssc_MarketplaceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const visit_ssc_marketplace = /** @type {((inputs?: Visit_Ssc_MarketplaceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visit_Ssc_MarketplaceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_visit_ssc_marketplace(inputs)
	if (locale === "es") return es_visit_ssc_marketplace(inputs)
	if (locale === "fr") return fr_visit_ssc_marketplace(inputs)
	if (locale === "de") return de_visit_ssc_marketplace(inputs)
	if (locale === "ja") return ja_visit_ssc_marketplace(inputs)
	if (locale === "zh") return zh_visit_ssc_marketplace(inputs)
	if (locale === "ar") return ar_visit_ssc_marketplace(inputs)
	if (locale === "id") return id_visit_ssc_marketplace(inputs)
	if (locale === "it") return it_visit_ssc_marketplace(inputs)
	if (locale === "ru") return ru_visit_ssc_marketplace(inputs)
	if (locale === "pt") return pt_visit_ssc_marketplace(inputs)
	return ko_visit_ssc_marketplace(inputs)
});